angular.module('zc.projects')

.directive 'zcBadgePositionAdjustmentEditor', (ProjectBadgePositionAdjustment, Meta, BaseProjectCrudEditor) ->

  class BadgePositionAdjustmentEditor extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality
      scope.devices = []

      Meta.getBadgePositionAdjustmentDevices().then (res) ->
        scope.devices = res

  editor = new BadgePositionAdjustmentEditor(
    ProjectBadgePositionAdjustment
    Meta
    '/templates/projects.settings/other/badge_position_adjustment_editor.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/other/badge_position_adjustment_editor.directive.coffee